import axios from 'axios'
import { useQuery } from 'react-query'
import LoadingWheel from './assets/LoadingWheel'
import { useEffect, useState, Fragment } from 'react'
import ImvCard from './ImvCard'
import { ImvCardModal } from './[modal]ImvCard'
import { Transition } from '@headlessui/react'
import { active_url, imvs_url } from '../services/host_data'
import { ImvsNotFound } from './assets/_ImvsNotFound'

//? This is Imovel view, that displays immobiles in grid view, in card formats
export default function ImvGridView({ isOpen, setOpen }) {
    const [content, setContent] = useState(null)
    const [selectedCard, setSelectedCard] = useState(null)

    //* Query Para Carregar os Imoveis
    const { data, isLoading, error } = useQuery('imoveis', async () => {
        return axios.get(active_url, {
            headers: {
                'api-key': 'xUp2jAz5hQZM#wCsKb',
                'Content-Type': 'application/json'
            },
        }).then((response) => response.data)
    })

    // useEffect(() => {
    //     console.log('Imoveis Ativos: ', data)
    // }, [data])


    const handleCardOpen = (imv) => {
        // console.log('Opened: ', imv.nreg)
        setOpen(true)
        setSelectedCard(imv)
    }
    const onClose = () => {
        setOpen(false)
        setSelectedCard(null)
    }

    return <>
        {selectedCard && (
            <Transition appear show={isOpen}>
                <Transition.Child
                    as='div'
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 scale-95"
                    enterTo="opacity-100 scale-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100 scale-100"
                    leaveTo="opacity-0 scale-95"
                >
                    <ImvCardModal imv={selectedCard} onClose={onClose} isOpen={isOpen} />
                </Transition.Child>
            </Transition>
        )}
        <section className='block bg-gradient-to-b from-[#0000006b] to-[#0000] p-10 mx-auto backdrop-blur w-full max-[1100px]:gap-y-5 max-md: max-[1100px]:py-2 max-md:justify-normal max-md:px-2 rounded-lg'>
            <h1 className='text-5xl max-[600px]:text3xl font-light text-center text-white'> Confira as Melhores Opções Perto de Voce: </h1>
            {isLoading && (
                <section className='w-full h-20 my-20 p-1 flex items-center'>
                    <LoadingWheel />
                </section>
            )}
            <div className='grid w-full grid-cols-3 justify-evenly pt-14 gap-4 
            md:grid-flow-row
            xl:grid-cols-5 max-[1760px]:grid-cols-3 max-[1100px]:grid-flow-row max-[1100px]:grid-cols-1'>
                {
                    data && data.map((imovel) => (
                        <ImvCard key={imovel.id} imv={imovel}
                            onOpen={handleCardOpen}
                        />
                    ))
                }
            </div>
            {data && data.length < 1 && (
                <ImvsNotFound />
            )}
        </section>
    </>
}
